import {  useEffect, useState } from "react";
import { Button } from "antd";
import { useTranslation } from "react-i18next";
import _ from "lodash";
import { enmFactSheetTemplateType } from "../../models/enums/FactSheetTemplateType";
import { mdlFactSheetReportContent } from "../../models/ui-models/FactSheetReportContent";
import * as  FactSheetTemplate  from '../fact-sheet/templates';
import { enmPdfRendererType } from "../../models/enums/PdfRenderer";
import { mdlLanguage } from "../../models/ui-models/Language";
import { mdlFactSheetTemplate } from "../../models/domain/FactSheetTemplate";
import { SFModal } from "../elements/SFModal";
import { FactSheetGiata } from "./FactSheetGiata";
import { mdlGiataRequest } from "../../models/ui-models/GiataRequest";

export type FactSheetReportProps = {
    data?: mdlFactSheetTemplate;
    selectedLanguage?: mdlLanguage;
    selectedHotel?: string;
    activeTemplate?:mdlFactSheetReportContent;
    handleActiveTemplate?: Function,
    handlePrint?: Function,
    handleTemplateSelect?: Function,
    handlePrintGiata?: Function,
    giataData?: mdlGiataRequest;
}

export const FactSheetReport = function FactSheetReport(props: FactSheetReportProps) {
    const [isModalVisible, setIsModalVisible] = useState<boolean>(false);
    const [templates, setTemplates] = useState<mdlFactSheetReportContent[]>();
    const [activeTemplate, setActiveTemplate] = useState<mdlFactSheetReportContent>();
    const { t } = useTranslation();

    useEffect(() => {
        if(props.selectedHotel){
            setTemplates([])
            handleTemplates(props.selectedHotel, props.selectedLanguage,undefined);
        }
        if(props.data && props.selectedHotel){
            setTemplates([])
            handleTemplates(props.selectedHotel , props.selectedLanguage,props.data);
        }
    }, [props]);

    
    const handlePrint = (selectedHotel: string, rendererType: enmPdfRendererType) => {
        props.handlePrint && props.handlePrint(selectedHotel,rendererType)
    }

    const handleTemplates = (selectedHotel:string, selectedLanguage:mdlLanguage | undefined,data : mdlFactSheetTemplate | undefined) => {
        const _templates:mdlFactSheetReportContent[] = [
            {
                key : enmFactSheetTemplateType.LUXURY,
                template : enmPdfRendererType.FactSheetTemplateLuxury,
                content : <FactSheetTemplate.LuxuryTemplate data={data} selectedHotel={selectedHotel} selectedLanguage={selectedLanguage}/>
            },
            {
                key : enmFactSheetTemplateType.RESORT,
                template : enmPdfRendererType.FactSheetTemplateResort,
                content : <FactSheetTemplate.ResortTemplate data={data} selectedHotel={selectedHotel} selectedLanguage={selectedLanguage}/>
            },
            {
                key : enmFactSheetTemplateType.CITY,
                template : enmPdfRendererType.FactSheetTemplateCity,
                content : <FactSheetTemplate.CityTemplate data={data} selectedHotel={selectedHotel} selectedLanguage={selectedLanguage}/>
            }
        ];

        setTemplates(_templates);
    }

    const handleTemplateChange = (item:enmFactSheetTemplateType) => {
        const itemFind = _.find(templates,((x:mdlFactSheetReportContent) => 
        { return x.key == item}));
        if(itemFind && props.handleActiveTemplate)
            props.handleActiveTemplate(itemFind)
        if(itemFind)
            setActiveTemplate(itemFind as mdlFactSheetReportContent)

        props.handleTemplateSelect &&  props.handleTemplateSelect(item);
    }
    const handleSendToGiata = (status:boolean) => {
        setIsModalVisible(status);
    };

    return (
        <>
            <SFModal
                width={window.innerWidth * 60 / 100}
                open={isModalVisible}
                toggler={() => { setIsModalVisible(!isModalVisible) }}
                body={<FactSheetGiata data={props.giataData} handlePrint={props.handlePrintGiata} printMode={false} fnModalClose={() => setIsModalVisible(!isModalVisible)} />}
                title={t("factSheet.giataContract")}
            />
            <div className="row">
                <div className="col">
                    <Button className="btn btn-outline-warning me-2" onClick={() => handleTemplateChange(enmFactSheetTemplateType.LUXURY)}>Luxury Hotel Template</Button>
                    <Button className="btn btn-outline-primary me-2" onClick={() => handleTemplateChange(enmFactSheetTemplateType.CITY)}>City Hotel Template</Button>
                    <Button className="btn btn-outline-secondary me-2" onClick={() => handleTemplateChange(enmFactSheetTemplateType.RESORT)}>Resort Hotel Template</Button>
                </div>
                <div className="col text-end">
                    {
                        activeTemplate && props.selectedHotel &&
                        <>
                        {/*<Button className="btn btn-dark me-2" onClick={() => handleSendToGiata(true)}>{t("factSheet.sendToGiata")}</Button>*/}
                        <Button className="btn btn-dark me-2" onClick={() => handlePrint(props.selectedHotel ?? "",activeTemplate.template)}>{t("common.print")}</Button>
                        </>
                    }
                </div>
            </div>
            <div className="row">
                <div className="col-12 mt-4">
                    {
                        activeTemplate &&
                        activeTemplate.content
                    }
                </div>
            </div>
        </>
    )
}
